/**
 * Creates an image picker input group for Drawflow nodes.
 *
 * @param {number} nodeId - The Drawflow node ID
 * @param {string} uniqueName - The df-attribute name (e.g. 'frageimg', 'answer1img')
 * @param {string} dfAttr - The df-attribute for data binding (e.g. 'df-frageimg')
 * @returns {string} HTML string for the image picker
 */
export function createImagePicker(nodeId, uniqueName, dfAttr) {
  const inputId = `node${nodeId}-${uniqueName}`;

  return `
        <div class="input-group">
            <input type="text" id="${inputId}" readonly
                class="form-control form-control-sm field-media-input"
                data-node-id="${nodeId}" data-unique-name="${uniqueName}" ${dfAttr}>
            <button type="button" class="btn btn-sm btn-warning survey-img-upload"
                data-target-id="${inputId}" title="Bild auswählen">
                <i class="bi bi-upload text-white"></i>
            </button>
            <button type="button" class="btn btn-sm btn-danger survey-img-clear"
                data-target-id="${inputId}" title="Leeren">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>`;
}

/**
 * Initializes click handlers for image picker buttons within a container.
 * Should be called after new nodes are created.
 *
 * @param {HTMLElement} container - The container to search for buttons
 * @param {object} editor - The Drawflow editor instance
 */
export function initImagePickerEvents(container, editor) {
  // Wenn MediaModal einen Wert setzt, Drawflow-Node synchronisieren
  container.addEventListener("change", (e) => {
    const field = e.target.closest(".field-media-input");
    if (field) syncImageToNode(field, editor);
  });

  container.addEventListener("click", (e) => {
    const uploadBtn = e.target.closest(".survey-img-upload");
    if (uploadBtn) {
      const targetId = uploadBtn.dataset.targetId;
      if (typeof window.MediaModal !== "function") {
        console.error(
          "MediaModal is not loaded. Please make sure media.js is included in the page.",
        );
        return;
      }
      if (!window._surveyMediaModal) {
        window._surveyMediaModal = new window.MediaModal(true);
        window.Vvveb = window.Vvveb || {};
        window.Vvveb.MediaModal = window._surveyMediaModal;
      }
      window._surveyMediaModal.open({ targetInput: "#" + targetId });
    }

    const clearBtn = e.target.closest(".survey-img-clear");
    if (clearBtn) {
      const targetId = clearBtn.dataset.targetId;
      const targetInput = document.getElementById(targetId);
      if (targetInput) {
        targetInput.value = "";
        targetInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });
}

function syncImageToNode(field, editor) {
  const nodeId = field.dataset.nodeId;
  const name = field.dataset.uniqueName;
  if (nodeId && name && editor.drawflow.drawflow.Home.data[nodeId]) {
    editor.drawflow.drawflow.Home.data[nodeId].data[name] = field.value;
  }
}
